import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-4 items-center" }

import LangSelection from "./LangSelection.vue";
import SoundControl from "./SoundControl.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LangSelection),
    _createVNode(SoundControl)
  ]))
}
}

})